var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27911_594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 15C9 12.172 9 10.757 9.879 9.879C10.757 9 12.172 9 15 9H16C18.828 9 20.243 9 21.121 9.879C22 10.757 22 12.172 22 15V16C22 18.828 22 20.243 21.121 21.121C20.243 22 18.828 22 16 22H15C12.172 22 10.757 22 9.879 21.121C9 20.243 9 18.828 9 16V15Z",
    stroke: "#8C8C8C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15C9 12.172 9 10.757 9.879 9.879C10.757 9 12.172 9 15 9H16C18.828 9 20.243 9 21.121 9.879C22 10.757 22 12.172 22 15V16C22 18.828 22 20.243 21.121 21.121C20.243 22 18.828 22 16 22H15C12.172 22 10.757 22 9.879 21.121C9 20.243 9 18.828 9 16V15Z",
    stroke: "#8C8C8C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 9C16.997 6.043 16.953 4.511 16.092 3.462C15.9259 3.25965 15.7404 3.07409 15.538 2.908C14.43 2 12.788 2 9.5 2C6.213 2 4.569 2 3.462 2.908C3.25965 3.07409 3.07409 3.25965 2.908 3.462C2 4.57 2 6.212 2 9.5C2 12.787 2 14.431 2.908 15.538C3.07409 15.7404 3.25965 15.9259 3.462 16.092C4.512 16.952 6.042 16.998 9 17",
    stroke: "#8C8C8C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 9C16.997 6.043 16.953 4.511 16.092 3.462C15.9259 3.25965 15.7404 3.07409 15.538 2.908C14.43 2 12.788 2 9.5 2C6.213 2 4.569 2 3.462 2.908C3.25965 3.07409 3.07409 3.25965 2.908 3.462C2 4.57 2 6.212 2 9.5C2 12.787 2 14.431 2.908 15.538C3.07409 15.7404 3.25965 15.9259 3.462 16.092C4.512 16.952 6.042 16.998 9 17",
    stroke: "#8C8C8C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27911_594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.51b665a3b2feab9c8431cb0a7117cdfc.svg";
export { ForwardRef as ReactComponent };